(() => {
  const initialize = () => {
    const root = document.querySelector('[data-product-offer-switcher]')?.closest('product-info');
  if (!root || root.dataset.travelSetPickerInitialized === 'true') return;

  const form = root.querySelector('product-form form');
  const productForm = root.querySelector('product-form');
  const offerButtons = [...root.querySelectorAll('[data-offer-value]')];
  const price = root.querySelector('[id^="price-"]');
  const priceTemplate = root.querySelector('[data-travel-set-price-template]');
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const sweatpantsData = root.querySelector('[data-travel-set-variants]');
  const hoodieData = root.querySelector('variant-radios script');
  if (!form || !productForm || !sweatpantsData || !hoodieData) {
    return;
  }

  let sweatpantsVariants;
  let hoodieVariants;
  try {
    sweatpantsVariants = JSON.parse(sweatpantsData.textContent);
    hoodieVariants = JSON.parse(hoodieData.textContent);
  } catch (error) {
    return;
  }
  const isSet = () => form.elements.Offer?.value?.includes('Set');
  const selected = (name) => form.elements[name]?.value;

  const matchingBundleVariant = () => sweatpantsVariants.find(
    (variant) => variant.option1 === selected('Color') && variant.option2 === selected('Size')
  );

  const updatePrice = () => {
    if (isSet() && priceTemplate && price) price.innerHTML = priceTemplate.innerHTML;
  };

  const updateUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('offer', isSet() ? 'set' : 'hoodie');
    window.history.replaceState({}, '', url);
  };

  const submitSet = async (event) => {
    if (!isSet()) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    const bundle = matchingBundleVariant();
    const button = form.querySelector('[type="submit"]');
    if (!bundle || !button) return;

    button.disabled = true;
    button.classList.add('loading');
    // Sets bypass the native FormData submission, so carry its order notes too.
    const properties = {};
    for (const [name, value] of new FormData(form)) {
      const match = name.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    }
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: bundle.id, quantity: 1, properties }],
          sections: cart?.getSectionsToRender?.().map((section) => section.id),
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add the Travel Set.');
      if (cart) {
        cart.setActiveElement(document.activeElement);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'travel-set-picker',
            productVariantId: bundle.id,
            cartData: result,
          });
        }
        cart.renderContents(result);
      } else {
        window.location.assign(window.Shopify.routes.root + 'cart');
      }
    } catch (error) {
      productForm.handleErrorMessage(error.message);
    } finally {
      button.disabled = false;
      button.classList.remove('loading');
    }
  };

  offerButtons.forEach((button) => {
    button.addEventListener('click', () => {
      window.setTimeout(() => {
        updatePrice();
        updateUrl();
      }, 400);
    });
  });
  form.addEventListener('submit', submitSet, true);
  form.addEventListener('change', updatePrice);
  updatePrice();
      root.dataset.travelSetPickerInitialized = 'true';
  };

  const start = () => {
    const switcher = document.querySelector('[data-product-offer-switcher]');
    const root = switcher?.closest('product-info');
    if (root && root.dataset.travelSetPickerInitialized !== 'true') initialize();
  };
  start();
  window.setInterval(start, 250);
})();
